import React, { useContext, useState, useEffect } from 'react';
import { DataContext } from '../contexts/DataContext';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import logo from '../wisdom.png';
// Import your payment requests related card components
import PaymentAdvanceCountCard from './PaymentAdvanceCountCard';
import PaymentAdvanceStatusCard from './PaymentAdvanceStatusCard';
import PaymentAdvanceExpensesSummaryCard from './PaymentAdvanceExpenseSummaryCard';
import PaymentAdvanceExpensesChart from './PaymentAdvancesExpenseChart';
import PaymentAdvancesPerCustomerChart from './PaymentAdvancesPerCustomerChart';


function PaymentRequestsDashboard() {
    const { paymentRequests, fetchDataBasedOnFilter } = useContext(DataContext);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [typeOptions, setTypeOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    useEffect(() => {
        if (paymentRequests) {
            const uniqueTypes = Array.from(new Set(paymentRequests.map(pr => pr.type)))
                .map(type => ({ value: type, label: type }));
            setTypeOptions(uniqueTypes);

            const uniqueStatuses = Array.from(new Set(paymentRequests.map(pr => pr.status)))
                .map(status => ({ value: status, label: status }));
            setStatusOptions(uniqueStatuses);
        }
    }, [paymentRequests]);

    const handleTypeFilterChange = (selectedOptions) => {
        const newSelectedTypes = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setSelectedTypes(newSelectedTypes);
        fetchDataBasedOnFilter({ types: newSelectedTypes, statuses: selectedStatuses });
    };

    const handleStatusFilterChange = (selectedOptions) => {
        const newSelectedStatuses = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setSelectedStatuses(newSelectedStatuses);
        fetchDataBasedOnFilter({ types: selectedTypes, statuses: newSelectedStatuses });
    };

    return (
        <div className="flex flex-col h-screen bg-gray-100">
            <nav className="w-full flex justify-between items-center px-6 py-4 bg-white shadow">
                <div className="flex items-center">
                    <img src={logo} alt="Company logo" className="h-12 mr-2" />
                </div>
                <div className="text-xl font-semibold text-gray-700">
                    Payment Requests Dashboard
                </div>
            </nav>
            <div className="flex-grow overflow-auto">
                <header className="px-6 py-8">
                    <h1 className="text-3xl font-bold text-gray-700 mb-4">Payment Requests Overview</h1>
                    <div className="flex flex-wrap -mx-2 mb-4">
                        <div className="px-2 w-full sm:w-1/2">
                            <Select
                                options={typeOptions}
                                isMulti
                                onChange={handleTypeFilterChange}
                                value={typeOptions.filter(option => selectedTypes.includes(option.value))}
                                placeholder="Filter by Request Type"
                            />
                        </div>
                        <div className="px-2 w-full sm:w-1/2">
                            <Select
                                options={statusOptions}
                                isMulti
                                onChange={handleStatusFilterChange}
                                value={statusOptions.filter(option => selectedStatuses.includes(option.value))}
                                placeholder="Filter by Status"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        <div><PaymentAdvanceCountCard /></div>
                        <div><PaymentAdvanceStatusCard /></div>
                        <div><PaymentAdvanceExpensesSummaryCard /></div>
                        <div><PaymentAdvanceExpensesChart /></div>
                        <div><PaymentAdvancesPerCustomerChart /></div>

                      

                        {/* ... other cards as needed */}
                    </div>
                </header>
            </div>
        </div>
    );
}

export default PaymentRequestsDashboard;
